import React from "react";
import PrimaryLayout from "../PrimaryLayout";
import ArticleArchiveLayout from "../ArticleArchiveLayout";

const layoutMap = {
  primary: PrimaryLayout,
  articleArchive: ArticleArchiveLayout,
  none: React.Fragment,
};

const LayoutManager = ({ layout = "primary", children, ...layoutProps }) => {
  const SelectedLayout = layoutMap[layout] || layoutMap.primary;
  return <SelectedLayout {...layoutProps}>{children}</SelectedLayout>;
};

export default LayoutManager;
